const INTERVIEW_VIDEO_PROVIDERS = {
  googleMeet: "GOOGLE_MEET",
  zoom: "ZOOM",
  microsoftTeams: "MICROSOFT_TEAMS",
  webex: "WEBEX",
  gotoMeeting: "GOTO_MEETING",
};

const isInterviewVideoProviderConnected = (provider, options) =>
  options.some((option) => option.videoProvider === provider && option.connected);

export { INTERVIEW_VIDEO_PROVIDERS, isInterviewVideoProviderConnected };
